module.exports = __webpack_public_path__ + "media/images/sale-ai_graph1-bc168b18.png";